
import React, { useState } from 'react';
import { TextField, Button, Container, Typography, Box } from '@mui/material';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../context/ToastContext';

const Register = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [validationErrors, setValidationErrors] = useState({});
  const { register } = useAuth();
  const navigate = useNavigate();
  const { showToast } = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = {};
    if (!name) errors.name = 'Tên là bắt buộc';
    if (!email) {
      errors.email = 'Email là bắt buộc';
    } else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(email)) {
      errors.email = 'Email không hợp lệ';
    }
    if (!password) errors.password = 'Mật khẩu là bắt buộc';

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    try {
      const success = await register(name, email, password);
      if (success) {
        showToast('Đăng ký thành công!', 'success');
        navigate('/dashboard');
      } else {
        showToast('Đăng ký thất bại. Vui lòng thử lại.', 'error');
        setValidationErrors({ general: 'Đăng ký thất bại. Vui lòng thử lại.' });
      }
    } catch (err) {
      console.error(err);
      let errorMessage = 'Đã xảy ra lỗi trong quá trình đăng ký.';
      if (err.response && err.response.data && err.response.data.message) {
        errorMessage = err.response.data.message;
      }
      showToast(errorMessage, 'error');
      setValidationErrors({ general: errorMessage });
    }
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Typography component="h1" variant="h5">
          Đăng ký
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="name"
            label="Tên"
            name="name"
            autoComplete="name"
            autoFocus
            value={name}
            onChange={(e) => setName(e.target.value)}
            error={!!validationErrors.name}
            helperText={validationErrors.name}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Địa chỉ Email"
            name="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            error={!!validationErrors.email}
            helperText={validationErrors.email}
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Mật khẩu"
            type="password"
            id="password"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            error={!!validationErrors.password}
            helperText={validationErrors.password}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            Đăng ký
          </Button>
          {validationErrors.general && (
            <Typography color="error" variant="body2" sx={{ mt: 2 }}>
              {validationErrors.general}
            </Typography>
          )}
        </Box>
      </Box>
    </Container>
  );
};

export default Register;
